'use strict';
const mindmupProfile = require('./mindmup-profile'),
	profileDescriptionFromLicense = require('./profile-description-from-license'),
	observable = require('@mindmup/mapjs-core/src/util/observable'),
	PROVIDER_NAME = 'unknown-provider';
module.exports = function AuthenticationModel() {
	let profileRetriever = false, lastAuthenticatedProfle = false;
	const self = observable(this),
		getProfile = function () {
			if (!profileRetriever) {
				return Promise.resolve();
			}
			return Promise.resolve()
			.then(() => profileRetriever())
			.then(profile => {
				if (profile) {
					lastAuthenticatedProfle = profile;
				}
				return lastAuthenticatedProfle;
			})
			.catch(reason => {
				if (lastAuthenticatedProfle) {
					return lastAuthenticatedProfle;
				}
				throw reason;
			});
		},
		authenticatedProfile = function (profileFunc) {
			if (!profileFunc || typeof profileFunc !== 'function') {
				profileRetriever = false;
				lastAuthenticatedProfle = false;
				throw 'invalid-args';
			}
			profileRetriever = profileFunc;
			getProfile()
			.then((profile) => profile && self.dispatchEvent('authenticatedProfile', profile));
		};

	self.signOut = function () {
		profileRetriever = false;
		lastAuthenticatedProfle = false;
		self.dispatchEvent('not-authenticated', 'signed-out');
	};

	self.signoutOthersRequired = () => {
		return getProfile()
		.then((profile) => profile && self.dispatchEvent('signoutOthersRequired', profile));
	};
	self.getProfile = function () {
		return getProfile();
	};
	self.getLicense = function () {
		return getProfile().then(function (profile) {
			if (profile && profile.license) {
				return profile.license;
			}
		});
	};

	//TODO: specs or refactor
	self.getUserId = async () => {
		const license = await self.getLicense();
		if (!license) {
			return;
		}
		if (license.subAccount) {
			return `${license.account}/${license.subAccount}`;
		}
		return license.account;
	};
	self.setSuggestedEmail = function (email) {
		self.dispatchEvent('suggestedEmail', email);
	};
	self.authenticationStarted = function () {
		profileRetriever = false;
		lastAuthenticatedProfle = false;
		self.dispatchEvent('authenticating');
	};
	self.authenticatedProfile = authenticatedProfile;
	self.authenticationFailed = function (failureReason) {
		profileRetriever = false;
		lastAuthenticatedProfle = false;
		self.dispatchEvent('not-authenticated', failureReason);
		if (failureReason) {
			self.dispatchEvent(failureReason);
		}
	};
	self.updatedLicense = (license) => {
		return getProfile()
		.then((profile) => {
			if (profile) {
				profile.license = license;
			} else {
				const description = profileDescriptionFromLicense(license);
				profile = mindmupProfile(PROVIDER_NAME, description, license);
			}
			authenticatedProfile(() => profile);
		});

	};
	self.fallBackProviderName = () => PROVIDER_NAME;
};
